

export const getTwilioConfiguration = (state) => state.twilio
